<template>
  <popup @close-popup="closePopup">
    <template v-slot:content>
      <div class="payment-structure">
        <span class="title payment-structure__title">
          {{
            store.state.repaymentSchedule[0].amountDue === store.state.repaymentSchedule[1].amountDue
              ? store.state.repaymentSchedule.length +
                ' payments of ' +
                moneyFormatter(store.state.repaymentSchedule[0].amountDue / 100, {
                  countryCode: 'ng',
                  showEmptyDecimal: false,
                  displayCurrencyAs: 'symbol',
                  officialLanguage: 'en'
                })
              : 'Pay ' +
                moneyFormatter(store.state.repaymentSchedule[0].amountDue / 100, {
                  countryCode: 'ng',
                  showEmptyDecimal: false,
                  displayCurrencyAs: 'symbol',
                  officialLanguage: 'en'
                }) +
                ' now & ' +
                moneyFormatter(store.state.repaymentSchedule[1].amountDue / 100, {
                  countryCode: 'ng',
                  showEmptyDecimal: false,
                  displayCurrencyAs: 'symbol',
                  officialLanguage: 'en'
                }) +
                ' over ' +
                (store.state.repaymentSchedule.length - 1) +
                ' installments'
          }}
        </span>
        <span class="subtitle payment-structure__subtitle"> Automatically debited from your account every 30 days </span>
        <div class="payment-structure__list">
          <div class="payment-structure__schedule" v-for="(schedule, index) of store.state.repaymentSchedule">
            <input
              type="radio"
              class="payment-structure__input"
              :id="'payment-schedule-' + index"
              name="payment-schedule"
              :checked="index === 0 && shouldCheck"
              disabled
            />
            <label :for="'payment-schedule-' + index">
              <span class="payment-structure__ball">&nbsp;</span>
              <p>
                Pay
                <span>
                  {{
                    moneyFormatter(schedule.amountDue / 100, {
                      countryCode: 'ng',
                      showEmptyDecimal: false,
                      displayCurrencyAs: 'symbol',
                      officialLanguage: 'en'
                    })
                  }}</span
                >
                {{ index === 0 ? 'Today' : index === 1 ? 'in ' + index + ' month' : 'in ' + index + ' months' }}
              </p>
            </label>
          </div>
        </div>
        <p class="payment-structure__message">
          Get your order first and pay only
          {{
            moneyFormatter(store.state.repaymentSchedule[0].amountDue / 100, {
              countryCode: 'ng',
              showEmptyDecimal: false,
              displayCurrencyAs: 'symbol',
              officialLanguage: 'en'
            })
          }}
          now. The remaining amount is split over in {{ store.state.repaymentSchedule.length - 1 }} installments
        </p>
        <div class="btn btn__primary btn--lg">
          <button @click="paymentStructureCheckout">Continue</button>
        </div>
      </div>
    </template>
  </popup>
</template>
<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue'
import Popup from '@/components/cards/popup/index.vue'
import store from '@/composables/useZeroWidgetStore/methods'
import { moneyFormatter } from '@/composables/useUtilities'

const shouldCheck = ref(false)
onBeforeMount(async () => {
  shouldCheck.value = true
})

const emit = defineEmits<{
  (e: 'close-popup'): void
}>()
const closePopup = () => {
  return emit('close-popup')
}

const paymentStructureCheckout = () => {
  store.actions.setComponent('review-payment')
}
</script>
<style lang=""></style>
